/**
 * Fime – Find a Distributor: country accordion (single-open) +
 * description "Read more" toggle.
 *
 * Independent classes/scoped selectors — does not collide with
 * find-us-worldwide.js even if both sections appear on the same page.
 */

const distributorItems = document.querySelectorAll('.distributor-country-item');

distributorItems.forEach(function (item) {
	const trigger = item.querySelector('.distributor-country-trigger');
	trigger.addEventListener('click', function () {
		const isOpen = item.classList.contains('is-open');
		distributorItems.forEach(function (otherItem) {
			otherItem.classList.remove('is-open');
		});
		if (!isOpen) {
			item.classList.add('is-open');
		}
	});
});

document.querySelectorAll('.distributor-readmore[data-toggle]').forEach(function (btn) {
	btn.addEventListener('click', function () {
		const target = document.getElementById(btn.dataset.toggle);
		if (!target) return;
		const isExpanded = target.classList.toggle('is-expanded');
		btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
		const label = btn.querySelector('[data-toggle-label]');
		if (label) label.textContent = isExpanded ? 'Read less' : 'Read more';
	});
});
